import React, { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { isChunkLoadError } from '../router/lazyWithRetry';

const pageFrameStyle: React.CSSProperties = {
  minHeight: '100vh',
  padding: 24,
  background: '#f5f7fb',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const errorCardStyle: React.CSSProperties = {
  width: '100%',
  maxWidth: 640,
  borderRadius: 16,
  boxShadow: '0 20px 48px rgba(15, 23, 42, 0.08)',
  background: '#fff',
  padding: 32,
};

const primaryButtonStyle: React.CSSProperties = {
  height: 40,
  borderRadius: 8,
  border: '1px solid #1677ff',
  background: '#1677ff',
  color: '#fff',
  padding: '0 16px',
  cursor: 'pointer',
};

const secondaryButtonStyle: React.CSSProperties = {
  height: 40,
  borderRadius: 8,
  border: '1px solid #cbd5e1',
  background: '#fff',
  color: '#0f172a',
  padding: '0 16px',
  cursor: 'pointer',
};

const getErrorMessage = (error: unknown) => {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'object' && error && 'statusText' in error) {
    return String((error as { statusText?: unknown }).statusText || '页面加载失败');
  }

  return '页面加载失败';
};

const RouteErrorFallback: React.FC = () => {
  const error = useRouteError();
  const chunkError = isChunkLoadError(error);
  const message = getErrorMessage(error);
  const autoReloadKey = `chunk-auto-reload:${window.location.pathname}`;

  useEffect(() => {
    if (!chunkError) {
      return;
    }

    if (window.sessionStorage.getItem(autoReloadKey) === '1') {
      window.sessionStorage.removeItem(autoReloadKey);
      return;
    }

    window.sessionStorage.setItem(autoReloadKey, '1');
    window.location.reload();
  }, [autoReloadKey, chunkError]);

  return (
    <div style={pageFrameStyle}>
      <section style={errorCardStyle}>
        <h1 style={{ margin: '0 0 12px', fontSize: 24, color: '#0f172a' }}>
          {chunkError ? '页面资源已更新' : '页面加载失败'}
        </h1>
        <p style={{ margin: '0 0 20px', color: '#64748b' }}>
          {chunkError ? '前端资源版本已变化，重新加载后即可恢复。' : '应用在渲染当前页面时发生错误。'}
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          <button type="button" style={primaryButtonStyle} onClick={() => window.location.reload()}>
            重新加载
          </button>
          <button type="button" style={secondaryButtonStyle} onClick={() => window.location.assign('/')}>
            返回首页
          </button>
        </div>
        <p style={{ margin: '20px 0 0', color: '#64748b' }}>{message}</p>
      </section>
    </div>
  );
};

export default RouteErrorFallback;
